import { Pawn } from './pawn';
import { GDM } from '../helpers/datamanager';
import { ObjectAnimator } from '../animators/objectanimator';
import { InputManager } from '../controls/inputmanager';
import { OrthoSprite } from '../helpers/orthosprite';
import { itemDropBounceEnabled } from '../constants';
import { TextureManager } from '../datamanagers/texturemanager';

let altHeld = false;
const MIN_ITEM_PICK_SIZE = 1;
InputManager.on('keydown', (e: KeyboardEvent) => { if (e.key === 'Alt') altHeld = true; });
InputManager.on('keyup', (e: KeyboardEvent) => { if (e.key === 'Alt') altHeld = false; });

export class ItemPawn extends Pawn {
    owner: any;
    nameTag: any;

    constructor(go: any) {
        super();
      if (go) {
        this.owner = go;
      }
    }

    createNamePlate() {
      if (!this.owner) return;
      if (this.owner.isVendingProp) {
        const sign = new OrthoSprite(new THREE.SpriteMaterial({
          map: TextureManager.load('3DDATA/CONTROL/RES/SHOPBOX01.DDS', null),
          transparent: true,
          depthWrite: false,
        }));
        sign.position.set(0, 0, 2.5);
        sign.scale.set(256, 32, 1);
        this.rootObj.add(sign);

        const canvas = document.createElement('canvas');
        canvas.width = 256;
        canvas.height = 32;
        const context = canvas.getContext('2d');
        context.font = 'bold 15px Arial';
        context.fillStyle = '#ffffff';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(this.owner.name || '', 128, 16, 232);
        const texture = new THREE.CanvasTexture(canvas);
        const label = new OrthoSprite(new THREE.SpriteMaterial({
          map: texture,
          transparent: true,
          depthWrite: false,
        }));
        label.position.set(0, 0, 2.51);
        label.scale.copy(sign.scale);
        this.rootObj.add(label);
        this.nameTag = sign;
        return;
      }
      const texture = ui.createNamePlate(this.owner);
      const material = new THREE.SpriteMaterial({
        map: texture,
        color: 0xffffff,
      });
      material.depthWrite = false;
      const sprite = new OrthoSprite(material);
      sprite.position.set(0, 0, 0.5);
      sprite.scale.set(texture.image.width, texture.image.height, 1);
      sprite.offset.set(0, -24, 0);
      sprite.visible = altHeld || !!this.owner?.isVendingProp;
      this.rootObj.add(sprite);
      this.nameTag = sprite;
    }

    update(delta: number) {
      super.update(delta);
      if (this.nameTag) {
        this.nameTag.visible = altHeld || !!this.owner?.isVendingProp;
      }
    }

    _setModel(modelMgr: any, modelIdx: any, onReady?: () => void) {
      const model = modelMgr.createForStatic(modelIdx, null, null, () => {
        // Cached meshes may finish synchronously, before `model` is assigned.
        Promise.resolve().then(() => {
          const bounds = new THREE.Box3().setFromObject(model);
          if (!bounds.isEmpty()) {
            const size = bounds.getSize(new THREE.Vector3());
            this.boundingBox.copy(bounds);
            this.boundingBoxObj.scale.set(
              Math.max(size.x, MIN_ITEM_PICK_SIZE),
              Math.max(size.y, MIN_ITEM_PICK_SIZE),
              Math.max(size.z, MIN_ITEM_PICK_SIZE),
            );
            bounds.getCenter(this.boundingBoxObj.position);
          }
          if (onReady) onReady();
        });
      });
      if (itemDropBounceEnabled) {
        GDM.get('fielditem_ani', function(itemAni: any) {
          const ani = new ObjectAnimator(model, itemAni);
          ani.loop = 0;
          ani.once('finish', function() {
            ani.stop();
          });
          ani.play();
        });
      }
      this.rootObj.add(model);
      this.createNamePlate();
    }

    setModel(modelIdx: any, callback: any) {
      GDM.get('fielditem_models', (modelList: any) => {
        this._setModel(modelList, modelIdx);
        if (callback) {
          callback();
        }
      });
    }

}

